import React from 'react';
import styled from 'styled-components';

import Link from '@webtv/components/link';
import Typography from '@webtv/components/typography';

import { headerMapper } from '../cookie-banner-dialog';

const CookieBannerDialogSectionItemRoot = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(1)};
  font-size: ${(props) => props.theme.typography.size.md};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const CookieBannerDialogSectionItemTitle = styled(Typography).attrs({ component: 'span' })`
  font-weight: ${(props) => props.theme.typography.weight.regular};
`;

interface Props {
  header: string;
  content: string;
}

export const CookieBannerDialogSectionItem: React.FC<Props> = (props: Props) => {
  const { header, content } = props;

  return (
    <CookieBannerDialogSectionItemRoot>
      <CookieBannerDialogSectionItemTitle>{header}:&nbsp;</CookieBannerDialogSectionItemTitle>

      {header === headerMapper.privacy ? (
        <Link color="inherit" href={content} target="_blank" rel="noreferrer">
          {content}
        </Link>
      ) : (
        <Typography component="span">{content}</Typography>
      )}
    </CookieBannerDialogSectionItemRoot>
  );
};

export default React.memo(CookieBannerDialogSectionItem);
